import { styled } from "@mui/material/styles";
import Box, { BoxProps } from "@mui/material/Box";

export const DaGridContainer = styled(Box)<BoxProps>(({ theme }) => ({
    '& .MuiDataGrid-root .MuiDataGrid-row': {
        '&:nth-of-type(2n)': {
            backgroundColor: '#f6f6f6',
        },
        '&:hover, &.Mui-hovered, &.Mui-selected': {
            backgroundColor: '#effbfe', //#f7fbfe
        },

    },

    '& .MuiDataGrid-root .MuiDataGrid-columnHeader': {
        backgroundColor: '#d9dfe3',
        '&:hover': {
            backgroundColor: '#eeeeee',
        },
        '& .MuiDataGrid-columnSeparator': {
        color: '#abacad'
        },
    },
}));




